import { numberParser, stringParser } from '../inboundParsers';
export const PLAYER_CHAT_PAYLOAD_DEFINITION = {
    numTimesToFlatSplit: 3,
    definitionParts: [
        { name: 'playerId', parser: numberParser },
        { name: 'username', parser: stringParser },
        { name: 'html', parser: stringParser }
    ]
};
